/**
 * Logs an error to the console (in development) or a external service (in production)
 *
 * @param error - The error to log
 * @param info - Additional information about the error, specifically the component stack
 */
export const logError = (
  error: Error,
  info: { componentStack?: string | null },
) => {
  if (import.meta.env.DEV) {
    console.log('Caught error:', error);
    console.log('Error details:', info);
  } else {
    // TODO: Log error to an external service in production
  }
};
